/* eslint-disable no-const-assign */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import JOI from 'joi-browser';
import './../../../assets/css/requestimates.css';
import { Modal, Button, Form } from 'react-bootstrap';
import { isMultiLocation, isAllLocations, getLocationName, getLocationBadgeColor } from '../../../util/locationUtils';
import Referral from "./referral";
import ReferralState from "./referralState";
import DeleteOrLossModal from "./../../partial/DeleteOrLossModal";
import { HTTPService } from "./../../../services/httpService";
import { convertToUTC, convertFromUTC } from '../../../util/convert_timezone';
import ReactGA from 'react-ga4';

const API = new HTTPService();

class Referrals extends Component {
  state = {
    referrals: [],
    customerId: 0,
    customerName: "",
    customerEmail: "",
    selectedReferral: {},
    activePage: 1,
    startDate: moment().format("YYYY-MM-DD"),
    vin: "",
    vehicleEntered: {},
    vinGood: false,
    prevMode: "",
    userType: this.props.userType,
    typeId: this.props.typeId,
    user: this.props.user,
    companyName: this.props.companyName,
    company: this.props.company,
    hiddenList: false,
    authenticated: 0,
    action: "display",
    errors: {},
    showHelpVideo: false,
    data: {
      email: "",
      name: "",
      vin: ""
    },
    // Lead form fields for installers
    phone: "",
    serviceInterest: "",
    // Vehicle dropdown state
    years: [],
    makes: [],
    models: [],
    selectedYear: "Year",
    selectedMake: "Make",
    selectedModel: "Model",
    selectedMakeObj: null,
    selectedModelObj: null,
    // Refresh state
    refreshing: false,
    // Filter state
    listFilter: '',
    showFilterDropdown: false,
    // Delete/close state
    showDeleteConfirm: false,
    referralToDelete: null,
    showCloseLeadModal: false,
    referralToClose: null,
    // Location assignment state
    showLocationRequiredModal: false,
    referralNeedingLocation: null,
    modalSelectedLocationId: ''
  };

  // Refresh the list data
  handleRefresh = () => {
    this.setState({ refreshing: true });
    window.location.reload();
  };

  schema = {
    email: JOI.string().email().required().label('email'),
    name: JOI.string().required().label('name'),
    vin: JOI.string().regex(/[A-HJ-NPR-Z0-9|a-hj-npr-z0-9]{17}/).required().label('vin')
  };

  async componentDidMount() {
    if (this.state.userType === "dealer") {
      const referralList = `/referrals/${this.state.user.User_id}`;
      const { data } = await API.get(referralList);
      const referrals = Array.isArray(data) ? data : (data?.rows || data?.referrals || []);
      this.setState({ referrals });
    } else if (this.state.userType === "installer") {
      const userRole = this.props.user?.role || this.props.user?.user_role;
      const isTech = userRole === 'technician';
      const specialistReferralList = isTech
        ? `/referrals/${this.state.user.User_id}`
        : `/referrals/specialist/${this.state.typeId}`;
      const { data } = await API.get(specialistReferralList);
      const referrals = Array.isArray(data) ? data : (data?.rows || data?.referrals || []);
      this.setState({ referrals });

      // Initialize years for vehicle dropdown
      const end = moment().add(1, 'years').year();
      const start = 1950;
      const years = [];
      for (let i = end; i >= start; i--) {
        years.push(i);
      }
      years.unshift("Year");
      this.setState({ years });
    }
  }

  capitalizeWords = (str) => {
    if (!str) return "";
    return str.split(" ").map(word => word.includes("-")
      ? word.split("-").map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()).join("-")
      : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(" ");
  }

  sendEmail = async (referral) => {
    const firstName = this.state.data.name.split(" ")[0];
    const segmentData = {
      customerId: this.state.customerId,
      dealer: this.props.companyName,
      year: this.state.vehicleEntered.ModelYear,
      make: this.state.vehicleEntered.Make,
      model: this.state.vehicleEntered.Model,
      firstName: _.capitalize(firstName),
      id: referral,
      email: this.state.data.email
    };

    await API.post(`/mailchimp/`, segmentData);
  };

  readVIN = async (vin) => {
    const { data: vehicle } = await API.get(`/vin/?Id=${vin}`);
    this.setState({ vehicleEntered: vehicle.Results[0] });
  };

  addReferral = async (referral) => {
    const { data: added } = await API.post(`/referrals/`, referral);
    return added;
  };

  addCustomer = async (customer) => {
    const { data: customerId } = await API.post(`/customers`, customer);
    this.setState({ customerId });
    return customerId;
  };

  addVehicle = async (vehicle) => {
    const { data: vehicleId } = await API.post(`/vehicles`, vehicle);
    this.setState({ vehicleId });
    return vehicleId;
  };

  handleVINChange = async (e) => {
    const vin = e.currentTarget.value.trim().toUpperCase();
    const vinGood = vin.length === 17 && /[A-HJ-NPR-Z0-9]{17}/.test(vin);
    this.setState({ vin, vinGood });
  };

  // Add these new methods to the Referrals class
  handleClaimReferral = async (referral, locationId) => {
    try {
      const claimData = {
        specialist_name: this.state.company.Installer_Name,
        specialist_phone: this.state.company.installer_phone_number,
        specialist_email: this.state.company.installer_email,
        specialist_business: this.state.company.Installer_Name,
        referral_id: referral.referral_id,
        claim_token: referral.claim_token
      };

      await API.post('/claimreferral', claimData);

      // If a locationId was provided (claim-for-location flow), assign it before reload
      if (locationId) {
        await API.patch(`/referrals/${referral.referral_id}/location`, { locationId });
        await this.addReferralState(referral.referral_id, 'LOCATION_ASSIGNED');
      }

      alert('Referral claimed successfully!');
      window.location.reload();

    } catch (error) {
      console.error('Error claiming referral:', error);
      alert('Failed to claim referral. Please try again.');
    }
  };

  handleConvertToEstimate = (referral) => {
    // Guard: multi-location installer must assign a location before converting
    const { locations } = this.props;
    if (isMultiLocation(locations) && !referral.location_id) {
      this.setState({ showLocationRequiredModal: true, referralNeedingLocation: referral });
      return;
    }

    const referralData = {
      customer: referral.customer_id,
      customerName: referral.customer_name,
      customerEmail: referral.customer_Email_Address,
      vehicle: {
        vin: referral.VIN,
        year: referral.Year,
        make: referral.Make,
        model: referral.Model
      },
      referralId: referral.referral_id,
      requestedService: referral.requested_service,
      locationId: referral.location_id || null
    };

    this.props.history.push('/newestimate', { referralData });
  };

  // Audit trail for referral state changes
  addReferralState = async (referralId, status, reasonCode = null, reasonNotes = null) => {
    const state = {
      referral_id: referralId,
      status: status,
      reason_code: reasonCode,
      notes: reasonNotes,
      changed_by: `user:${this.state.user.User_id}:${this.state.userType}`
    };
    await API.post('/referralState', state);
  };

  // Dealer: open simple confirm modal
  handleDeleteReferral = (referral) => {
    this.setState({ showDeleteConfirm: true, referralToDelete: referral });
  };

  // Dealer: confirm delete
  handleDeleteReferralConfirm = async () => {
    const { referralToDelete } = this.state;
    try {
      await API.put(`/referrals`, { referral_id: referralToDelete.referral_id, status: 'deleted' });
      await this.addReferralState(referralToDelete.referral_id, 'deleted', 'administrative_delete');

      const referrals = this.state.referrals.filter(r => r.referral_id !== referralToDelete.referral_id);
      this.setState({ referrals, selectedReferral: {}, showDeleteConfirm: false, referralToDelete: null });
      window.dispatchEvent(new Event('refreshNavbarCounts'));
    } catch (error) {
      console.error('Error deleting referral:', error);
      alert('Failed to delete referral. Please try again.');
    }
  };

  // Specialist: open DeleteOrLossModal in referral mode
  handleCloseLead = (referral) => {
    this.setState({ showCloseLeadModal: true, referralToClose: referral });
  };

  // Specialist: confirm close/loss from modal
  handleCloseLeadConfirm = async (result) => {
    const { referralToClose } = this.state;
    try {
      const newStatus = result.isLoss ? 'LOSS' : 'deleted';
      await API.put(`/referrals`, { referral_id: referralToClose.referral_id, status: newStatus });
      await this.addReferralState(referralToClose.referral_id, newStatus, result.reasonCode, result.reasonNotes);

      const referrals = this.state.referrals.filter(r => r.referral_id !== referralToClose.referral_id);
      this.setState({ referrals, selectedReferral: {}, showCloseLeadModal: false, referralToClose: null });
      window.dispatchEvent(new Event('refreshNavbarCounts'));
    } catch (error) {
      console.error('Error closing lead:', error);
      alert('Failed to close lead. Please try again.');
    }
  };

  handleAssignLocation = async (referral, locationId) => {
    try {
      await API.patch(`/referrals/${referral.referral_id}/location`, { locationId });
      await this.addReferralState(referral.referral_id, 'LOCATION_ASSIGNED');

      // Update local state
      const updatedReferrals = this.state.referrals.map(r =>
        r.referral_id === referral.referral_id ? { ...r, location_id: locationId } : r
      );

      // If viewing a specific location and the lead was transferred away,
      // clear the selection so the detail panel closes
      const { selectedLocationId } = this.props;
      const transferredAway = !isAllLocations(selectedLocationId)
        && String(locationId) !== String(selectedLocationId);

      const updatedSelected = transferredAway
        ? {}
        : (this.state.selectedReferral.referral_id === referral.referral_id
          ? { ...this.state.selectedReferral, location_id: locationId }
          : this.state.selectedReferral);

      this.setState({
        referrals: updatedReferrals,
        selectedReferral: updatedSelected,
        hiddenList: transferredAway ? false : this.state.hiddenList
      });
    } catch (error) {
      console.error('Error assigning location:', error);
      alert('Failed to assign location. Please try again.');
    }
  };

  validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const schema = { [name]: this.schema[name] };
    const { error } = JOI.validate(obj, schema);
    return error ? error.details[0].message : null;
  };

  handleDataChange = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);
    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];

    const data = { ...this.state.data };
    data[input.name] = input.value;

    this.setState({ data, errors });
  };

  handleOnClick = () => {
    this.setState({ action: "add" });
  };

  handlePhoneChange = ({ currentTarget: input }) => {
    // Strip non-digits and limit to 10 digits
    const digits = input.value.replace(/\D/g, '').slice(0, 10);
    const errors = { ...this.state.errors };

    if (digits.length === 10) {
      delete errors.phone;
    } else if (digits.length > 0) {
      errors.phone = 'Phone must be 10 digits';
    }

    this.setState({ phone: digits, errors });
  };

  formatPhoneDisplay = (phone) => {
    if (!phone) return '';
    if (phone.length <= 3) return phone;
    if (phone.length <= 6) return `(${phone.slice(0, 3)}) ${phone.slice(3)}`;
    return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
  };

  handleServiceChange = ({ currentTarget: input }) => {
    this.setState({ serviceInterest: input.value });
  };

  handleYearChange = async (event) => {
    const { value } = event.target;
    this.setState({
      selectedYear: value,
      selectedMake: "Make",
      selectedModel: "Model",
      makes: [],
      models: [],
      selectedMakeObj: null,
      selectedModelObj: null
    });

    if (value !== "Year") {
      const { data: makes } = await API.get(`/makes/${value}`);
      this.setState({ makes });
    }
  };

  handleMakeChange = async (event) => {
    const { value } = event.target;
    const selectedMakeObj = this.state.makes.find(make => make.name === value);

    this.setState({
      selectedMake: value,
      selectedMakeObj: selectedMakeObj,
      selectedModel: "Model",
      models: [],
      selectedModelObj: null
    });

    if (value !== "Make" && selectedMakeObj) {
      const vehicleRequest = this.state.selectedYear + selectedMakeObj.id_car_make;
      const { data: models } = await API.get(`/models/${vehicleRequest}`);
      this.setState({ models });
    }
  };

  handleModelChange = (event) => {
    const { value } = event.target;
    const selectedModelObj = this.state.models.find(model => model.name === value);

    this.setState({
      selectedModel: value,
      selectedModelObj: selectedModelObj
    });
  };

  handleCancel = () => {
    this.setState({ 
      selectedService: 0, 
      selectedReferral: {}, 
      action: "display", 
      hiddenList: false 
    });
  };

  handleDelete = () => {
    this.setState({ 
      selectedService: 0, 
      selectedReferral: {}, 
      action: "display", 
      hiddenList: false 
    });
  };

  handleReferralSelect = (referral, isMobile = false) => {
    this.setState({ 
      selectedReferral: referral, 
      selectedService: 0, 
      activePage: 1, 
      vinGood: false,
      hiddenList: isMobile
    });
  };

  handleShowHelpVideo = () => {
    this.setState({ showHelpVideo: true });
  };

  handleCloseHelpVideo = () => {
    this.setState({ showHelpVideo: false });
  };

  generateVIN = () => {
    // Generate a placeholder VIN: NV + timestamp
    return `NV${moment().format('YYYYMMDDHHmmss')}`;
  };

  handleSubmitLead = async () => {
    try {
      // 1. Create Customer
      const customer = {
        customerName: this.capitalizeWords(this.state.data.name),
        customerEmailAddress: this.state.data.email.toLowerCase(),
        customerPhoneNumber: this.state.phone,
        customerType: "Lead",
        owningInstaller: this.props.typeId
      };

      const customerId = await this.addCustomer(customer);

      // 2. Create Vehicle
      const generatedVIN = this.generateVIN();
      const selectedModelObj = this.state.selectedModelObj;
      const vehicle = {
        year: parseInt(this.state.selectedYear),
        make: this.state.selectedMake,
        model: this.state.selectedModel,
        vin: generatedVIN,
        size: selectedModelObj?.vehicleSize || 'M'
      };

      await this.addVehicle(vehicle);

      // 3. Create Referral/Lead (stays in Leads section until converted to estimate)
      // Using the specialist lead format from server
      // Include location_id: specific location view uses that location,
      // single-location installers auto-assign their only location
      const { locations } = this.props;
      const selectedLocId = this.props.selectedLocationId;
      const singleLocationId = (Array.isArray(locations) && locations.length === 1) ? locations[0].location_id : null;
      const assignLocationId = (!isAllLocations(selectedLocId) && selectedLocId)
        ? Number(selectedLocId)
        : (singleLocationId ? Number(singleLocationId) : null);

      const newReferral = {
        referralType: "organic",
        referralSourceId: this.props.typeId,
        customerId: customerId,
        vin: generatedVIN,
        claimedSpecialistId: this.props.typeId,
        claimedSpecialistName: this.props.company.Installer_Name,
        requestedService: this.state.serviceInterest,
        campaignId: 0,
        referringUserId: this.props.user.User_id,
        location_id: assignLocationId
      };

      await this.addReferral(newReferral);

      ReactGA.event({ category: 'Installer', action: 'Created Lead', label: 'prod' });

      // Refresh navbar counts to show updated lead count
      window.dispatchEvent(new Event('refreshNavbarCounts'));

      alert('Lead added successfully!');
      window.location = "/referrals";

    } catch (error) {
      console.error('Error creating lead:', error);
      alert('Error creating lead: ' + (error.response?.data?.message || error.message));
    }
  };

  handleSubmitReferral = async () => {
    await this.readVIN(this.state.data.vin);

    const vehicle = {
      year: this.state.vehicleEntered.ModelYear,
      make: this.state.vehicleEntered.Make,
      model: this.state.vehicleEntered.Model,
      vin: this.state.vehicleEntered.VIN
    };

    await this.addVehicle(vehicle);

    const prospect = {
      customerName: this.capitalizeWords(this.state.data.name),
      customerEmailAddress: this.state.data.email,
      owningInstaller: 0
    };

    await this.addCustomer(prospect);

    const newReferral = {
      userId: this.props.user.User_id,
      customerId: this.state.customerId,
      vin: vehicle.vin,
      dateAdded: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      dealerId: this.props.typeId,
      status: "NEW",
      refferingEmail : this.props.user.Email,
    };

    const sendThis = await this.addReferral(newReferral);
    alert("Sale Added to system");
    await this.sendEmail(sendThis);

    // Refresh navbar counts to show updated referral count
    window.dispatchEvent(new Event('refreshNavbarCounts'));

    window.location = "/referrals";
  };

  renderFilterDropdown = (referrals) => {
    const { listFilter, showFilterDropdown } = this.state;

    // Get unique utm_source values from current list
    const filterOptions = [...new Set(
      referrals.map(r => r.utm_source).filter(Boolean)
    )].sort();

    if (filterOptions.length === 0) return null;

    const isActive = listFilter !== '';

    return (
      <div style={{ position: 'relative' }}>
        <button
          className={`btn btn-sm btn-header-icon${isActive ? ' filter-active' : ''}`}
          onClick={() => this.setState({ showFilterDropdown: !showFilterDropdown })}
          title="Filter list"
        >
          <i className={`fa-sharp ${isActive ? 'fa-solid' : 'fa-regular'} fa-filter`}></i>
          {isActive && (
            <span style={{
              position: 'absolute', top: '-2px', right: '-2px',
              background: '#fff', color: '#5196d3', borderRadius: '50%',
              fontSize: '9px', fontWeight: 700, width: '14px', height: '14px',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              {referrals.filter(r => r.utm_source === listFilter).length}
            </span>
          )}
        </button>
        {showFilterDropdown && (
          <>
            <div style={{ position: 'fixed', inset: 0, zIndex: 1049 }}
              onClick={() => this.setState({ showFilterDropdown: false })} />
            <div className="filter-dropdown-menu">
              <div
                className={`filter-item${listFilter === '' ? ' active' : ''}`}
                onClick={() => this.setState({ listFilter: '', showFilterDropdown: false })}
              >
                All ({referrals.length})
              </div>
              <div className="filter-divider" />
              {filterOptions.map(source => {
                const count = referrals.filter(r => r.utm_source === source).length;
                return (
                  <div
                    key={source}
                    className={`filter-item${listFilter === source ? ' active' : ''}`}
                    onClick={() => this.setState({ listFilter: source, showFilterDropdown: false })}
                  >
                    {this.getSourceIcon(source)}
                    <span>{this.formatSourceLabel(source)} ({count})</span>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    );
  }

  render() {
    const { referrals, userType, action, selectedReferral, showHelpVideo, typeId } = this.state;
    const { locations, selectedLocationId } = this.props;
    const multiLoc = isMultiLocation(locations);
    const allLocView = isAllLocations(selectedLocationId);
    const isEmptyList = !Array.isArray(referrals) || referrals.length === 0;
    const userRole = this.props.user?.role || this.props.user?.user_role;
    const isTechnician = userType === 'installer' && userRole === 'technician';
    const namePage = isTechnician ? "My Leads" : (userType === "installer" ? "Leads" : "Referrals");
    const showFilter = userType === 'installer';
    const canCreateLead = userType === 'installer' && userRole !== 'admin' && userRole !== 'viewer';

    // Location filter: specific location view shows unclaimed + own location's leads
    const locationFiltered = (multiLoc && !allLocView)
      ? referrals.filter(r => !r.location_id || String(r.location_id) === String(selectedLocationId))
      : referrals;

    // Apply source filter on top of location filter
    const displayedReferrals = this.state.listFilter
      ? locationFiltered.filter(r => r.utm_source === this.state.listFilter)
      : locationFiltered;

    return (
      <React.Fragment>
        <div className="d-flex align-items-center justify-content-between d-lg-none d-sm-block p-2 list-header">
          <div className="d-flex align-items-center" style={{ gap: '4px' }}>
            {showFilter && this.renderFilterDropdown(locationFiltered)}
            <button
              className="btn btn-sm btn-header-icon"
              onClick={this.handleRefresh}
              disabled={this.state.refreshing}
              title="Refresh list"
            >
              <i className={`fa-sharp fa-regular fa-refresh ${this.state.refreshing ? 'fa-spin' : ''}`}></i>
            </button>
          </div>
          <h3 className="page-name mb-0">{namePage}</h3>
          {Object.keys(selectedReferral).length > 0 ? (
            <button
              type="button"
              className="btn btn-sm btn-header-icon"
              onClick={this.handleCancel}
            >
              <i className="fa-sharp fa-regular fa-times"></i>
            </button>
          ) : (
            <span style={{ width: '32px' }}></span>
          )}
        </div>

        <div className="row">
          <div className="col-lg-4 text-center d-none d-lg-block">
            <div className="d-flex align-items-center justify-content-between p-3 mb-0 corners list-header">
              <span style={{ width: '32px' }}></span>
              <h5 className="page-name mb-0">{namePage}</h5>
              <div className="d-flex align-items-center" style={{ gap: '4px' }}>
                {showFilter && this.renderFilterDropdown(locationFiltered)}
                <button
                  className="btn btn-sm btn-header-icon"
                  onClick={this.handleRefresh}
                  disabled={this.state.refreshing}
                  title="Refresh list"
                >
                  <i className={`fa-sharp fa-regular fa-refresh ${this.state.refreshing ? 'fa-spin' : ''}`}></i>
                </button>
              </div>
            </div>
            <ul className="list-group-fluid p-0 list-group-flush shadow bg-white corners">
              {userType === "dealer" && (
                <li className="list-group-item d-flex justify-content-center align-items-center corners">
                  <button
                    type="button"
                    onClick={this.handleOnClick}
                    className="button btn-success m-2 buttons"
                  >
                    NEW REFERRAL
                  </button>
                  <button
                    type="button"
                    onClick={this.handleShowHelpVideo}
                    className="btn btn-link p-1 ml-2"
                    title="Click for help video"
                    style={{ fontSize: '16px', color: '#6c757d' }}
                  >
                    <i className="fa-sharp fa-regular fa-question-circle"></i>
                  </button>
                </li>
              )}
              {canCreateLead && (
                <li className="list-group-item d-flex justify-content-center align-items-center corners">
                  <button
                    type="button"
                    onClick={this.handleOnClick}
                    className="button btn-success m-2 buttons"
                  >
                    NEW LEAD
                  </button>
                </li>
              )}

              {!isEmptyList && displayedReferrals.map(item => (
                <li
                  onClick={() => this.handleReferralSelect(item)}
                  key={item.referral_id}
                  className={item.referral_id === selectedReferral.referral_id ? "list-group-item active" : "list-group-item"}
                >
                  <small>
                    <div className="row">
                      <div className="col-2">
                        <b className={convertFromUTC(item.date_added || item.created_at).isSame(moment(), 'day') ? 'date-today' : ''}>{convertFromUTC(item.date_added || item.created_at).format("ddd MMM D")}</b>
                      </div>
                      <div className="col-8">
                        <div className="row"><div className="col">{item.Year} {item.Make} {item.Model}</div></div>
                        <div className="row">
                          <div className="col">
                            {item.customer_name}
                          </div>
                        </div>
                        {userType === "dealer" && (
                          <div className="row"><div className="col">{moment(item.expiration_date).diff(moment(), 'days')} days remaining</div></div>
                        )}
                        {userType === "installer" && (
                          <div className="row">
                            <div className="col">
                              {item.specialist_action === 'available' ? 'Available to Claim' : this.formatSourceLabel(item.utm_source, item.utm_medium)}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-2">
                        {this.iconState(item.status, item.specialist_action, item.utm_source, item.utm_medium)}
                        {multiLoc && item.location_id && (() => {
                          const loc = locations.find(l => String(l.location_id) === String(item.location_id));
                          return loc ? (
                            <div style={{
                              fontSize: '0.65rem', fontWeight: 600, color: '#fff',
                              backgroundColor: getLocationBadgeColor(item.location_id, locations),
                              borderRadius: '3px', padding: '1px 4px', marginTop: '2px',
                              whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'
                            }}>
                              {getLocationName(loc)}
                            </div>
                          ) : null;
                        })()}
                      </div>
                    </div>
                  </small>
                </li>
              ))}
            </ul>
          </div>

          {this.state.hiddenList === false && (
            <div className="col-lg-4 text-center d-lg-none d-sm-block">
              <ul className="list-group-fluid p-0 list-group-flush shadow bg-white">
                {userType === "dealer" && (
                  <li className="list-group-item d-flex justify-content-center align-items-center">
                    <button
                      type="button"
                      onClick={this.handleOnClick}
                      className="btn btn-success btn-lg mt-2 mb-2"
                    >
                      NEW REFERRAL
                    </button>
                    <button
                      type="button"
                      onClick={this.handleShowHelpVideo}
                      className="btn btn-link p-1 ml-2"
                      title="Click for help video"
                      style={{ fontSize: '18px', color: '#6c757d' }}
                    >
                      <i className="fa-sharp fa-regular fa-question-circle"></i>
                    </button>
                  </li>
                )}
                {canCreateLead && (
                  <li className="list-group-item d-flex justify-content-center align-items-center">
                    <button
                      type="button"
                      onClick={this.handleOnClick}
                      className="btn btn-success btn-lg mt-2 mb-2"
                    >
                      NEW LEAD
                    </button>
                  </li>
                )}

                {!isEmptyList && displayedReferrals.map(item => (
                  <li
                    onClick={() => this.handleReferralSelect(item, true)}
                    key={item.referral_id}
                    className={item.referral_id === selectedReferral.referral_id ? "list-group-item active" : "list-group-item"}
                  >
                    <small>
                      <div className="row">
                        <div className="col-2">
                          <b className={convertFromUTC(item.date_added || item.created_at).isSame(moment(), 'day') ? 'date-today' : ''}>{convertFromUTC(item.date_added || item.created_at).format("ddd MMM D")}</b>
                        </div>
                        <div className="col-8">
                          <div className="row"><div className="col">{item.Year} {item.Make} {item.Model}</div></div>
                          <div className="row">
                            <div className="col">
                              {item.customer_name}
                            </div>
                          </div>
                          {userType === "dealer" && (
                            <div className="row"><div className="col">{moment(item.expiration_date).diff(moment(), 'days')} days remaining</div></div>
                          )}
                          {userType === "installer" && (
                            <div className="row">
                              <div className="col">
                                {item.specialist_action === 'available' ? 'Available to Claim' : this.formatSourceLabel(item.utm_source, item.utm_medium)}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="col-2">
                          {this.iconState(item.status, item.specialist_action, item.utm_source, item.utm_medium)}
                          {multiLoc && item.location_id && (() => {
                            const loc = locations.find(l => String(l.location_id) === String(item.location_id));
                            return loc ? (
                              <div style={{
                                fontSize: '0.65rem', fontWeight: 600, color: '#fff',
                                backgroundColor: getLocationBadgeColor(item.location_id, locations),
                                borderRadius: '3px', padding: '1px 4px', marginTop: '2px',
                                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'
                              }}>
                                {getLocationName(loc)}
                              </div>
                            ) : null;
                          })()}
                        </div>
                      </div>
                    </small>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Mobile: only show when selected or adding. Desktop: always show */}
          <div className={(Object.keys(selectedReferral).length === 0 && action !== 'add') ? "col-lg-8 d-none d-lg-block" : "col-lg-8"}>
            {/* When nothing selected and not adding, just show the message */}
            {(Object.keys(selectedReferral).length === 0 && action !== 'add') && (
              <Referral
                selectedReferral={selectedReferral}
                displayedList={referrals}
                mode="referrals"
                userType={userType}
                typeId={typeId}
                onCancel={this.handleCancel}
                action={action}
              />
            )}

            {/* When something is selected or adding, show full detail panels */}
            {(Object.keys(selectedReferral).length > 0 || action === 'add') && (
              <React.Fragment>
                <div className="shadow-sm p-2 corners detail-panel-selected">
                  <button type="button" className="close d-none d-lg-block" onClick={this.handleCancel} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <br />
                  <Referral
                    selectedReferral={selectedReferral}
                    displayedList={referrals}
                    mode="referrals"
                    userType={userType}
                    typeId={typeId}
                    onCancel={this.handleCancel}
                    action={action}
                  />
                </div>
                <div className="shadow-sm p-3 corners bg-white">
                  <ReferralState
                  userType={userType}
                  typeId={typeId}
                  referral={selectedReferral}
                  displayedList={referrals}
                  locations={locations}
                  selectedLocationId={selectedLocationId}
                  onAssignLocation={this.handleAssignLocation}
                  userRole={userRole}
                  startDate={this.state.startDate}
                  errors={this.state.errors}
                  name={this.state.data.name}
                  onNameChange={this.handleDataChange}
                  email={this.state.data.email}
                  onEmailChange={this.handleDataChange}
                  onDelete={this.handleDelete}
                  onVINChange={this.handleDataChange}
                  vin={this.state.data.vin}
                  vehicleEntered={this.state.vehicleEntered}
                  vinGood={this.state.vinGood}
                  onSubmit={this.handleSubmitReferral}
                  onCancel={this.handleCancel}
                  action={action}
                  onClaimReferral={this.handleClaimReferral}
                  onConvertToEstimate={this.handleConvertToEstimate}
                  phone={this.formatPhoneDisplay(this.state.phone)}
                  onPhoneChange={this.handlePhoneChange}
                  serviceInterest={this.state.serviceInterest}
                  onServiceChange={this.handleServiceChange}
                  years={this.state.years}
                  makes={this.state.makes}
                  models={this.state.models}
                  selectedYear={this.state.selectedYear}
                  selectedMake={this.state.selectedMake}
                  selectedModel={this.state.selectedModel}
                  onYearChange={this.handleYearChange}
                  onMakeChange={this.handleMakeChange}
                  onModelChange={this.handleModelChange}
                  onSubmitLead={this.handleSubmitLead}
                  onDeleteReferral={this.handleDeleteReferral}
                  onCloseLead={this.handleCloseLead}
                />
                </div>
              </React.Fragment>
            )}
          </div>

          {showHelpVideo && (
            <>
              <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }}>
                <div className="modal-dialog modal-lg modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">How to Add a Referral</h5>
                      <button type="button" className="close" onClick={this.handleCloseHelpVideo}>
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body p-0">
                      <div style={{ width: '100%', aspectRatio: '16 / 12', minHeight: '480px' }}>
                        <iframe
                          src="https://scribehow.com/embed/How_To_Add_A_New_Referral_On_Jobvious__E4e5Z385QhKOKQuCPRsO0A?as=video"
                          width="100%"
                          height="100%"
                          allowFullScreen
                          style={{ border: 0 }}
                          title="How to Add a New Referral on Jobvious"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-backdrop fade show" onClick={this.handleCloseHelpVideo}></div>
            </>
          )}

          {/* Dealer: simple delete confirm modal */}
          <Modal show={this.state.showDeleteConfirm} onHide={() => this.setState({ showDeleteConfirm: false, referralToDelete: null })} centered>
            <Modal.Header closeButton>
              <Modal.Title>Delete Referral</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.referralToDelete && (
                <div>
                  <p>Are you sure you want to delete this referral?</p>
                  <div className="p-3 bg-light rounded mb-3">
                    <p className="mb-1"><strong>{this.state.referralToDelete.Year} {this.state.referralToDelete.Make} {this.state.referralToDelete.Model}</strong></p>
                    <p className="mb-0 text-muted">{this.state.referralToDelete.customer_name}</p>
                  </div>
                  <p className="text-muted small">This action cannot be undone.</p>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => this.setState({ showDeleteConfirm: false, referralToDelete: null })}>Cancel</Button>
              <Button variant="danger" onClick={this.handleDeleteReferralConfirm}>Delete</Button>
            </Modal.Footer>
          </Modal>

          {/* Specialist: close lead / record loss modal */}
          <DeleteOrLossModal
            show={this.state.showCloseLeadModal}
            request={this.state.referralToClose}
            mode="referral"
            onHide={() => this.setState({ showCloseLeadModal: false, referralToClose: null })}
            onConfirm={this.handleCloseLeadConfirm}
          />

          {/* Location Required Modal — shown when converting unassigned lead (multi-location) */}
          {multiLoc && (
            <Modal
              show={this.state.showLocationRequiredModal}
              onHide={() => this.setState({ showLocationRequiredModal: false, referralNeedingLocation: null })}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Assign Location</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>This lead must be assigned to a location before it can be converted to an estimate.</p>
                <Form.Group>
                  <Form.Label>Select a location</Form.Label>
                  <Form.Control
                    as="select"
                    value={this.state.modalSelectedLocationId || ''}
                    onChange={(e) => this.setState({ modalSelectedLocationId: e.target.value })}
                  >
                    <option value="" disabled>Choose location...</option>
                    {locations.map(loc => (
                      <option key={loc.location_id} value={loc.location_id}>
                        {getLocationName(loc)}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => this.setState({ showLocationRequiredModal: false, referralNeedingLocation: null, modalSelectedLocationId: '' })}
                >
                  Cancel
                </Button>
                <Button
                  variant="success"
                  disabled={!this.state.modalSelectedLocationId}
                  onClick={async () => {
                    const locId = Number(this.state.modalSelectedLocationId);
                    if (!locId || !this.state.referralNeedingLocation) return;
                    await this.handleAssignLocation(this.state.referralNeedingLocation, locId);
                    this.setState({ showLocationRequiredModal: false, referralNeedingLocation: null, modalSelectedLocationId: '' });
                  }}
                >
                  ASSIGN
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </div>
      </React.Fragment>
    );
  }

  formatSourceLabel = (utmSource, utmMedium) => {
    const source = utmSource?.toLowerCase() || '';
    const medium = utmMedium?.toLowerCase() || '';

    // Use utm_medium to distinguish within a source
    if (source === 'dealer') {
      if (medium === 'market') return 'Dealer (Marketplace)';
      if (medium === 'indirect') return 'Dealer (Indirect)';
      return 'Dealer Referral';
    }
    if (source === 'direct') {
      if (medium === 'returning') return 'Returning Customer';
      return 'Organic';
    }
    if (source === 'jobvious') return 'Campaign';

    const labelMap = {
      'google': 'Google',
      'facebook': 'Facebook',
      'instagram': 'Instagram',
      'tiktok': 'TikTok',
      'yelp': 'Yelp'
    };
    return labelMap[source] || (utmSource || 'Unknown');
  }

  getSourceIcon = (utmSource, utmMedium) => {
    const source = utmSource?.toLowerCase() || '';
    const medium = utmMedium?.toLowerCase() || '';

    const iconMap = {
      'dealer': { icon: 'fa-sharp fa-solid fa-handshake', tooltip: 'Dealer' },
      'jobvious': { icon: 'fa-sharp fa-solid fa-bullhorn', tooltip: 'Campaign' },
      'google': { icon: 'fa-brands fa-google', tooltip: 'Google' },
      'instagram': { icon: 'fa-brands fa-instagram', tooltip: 'Instagram' },
      'facebook': { icon: 'fa-brands fa-facebook', tooltip: 'Facebook' },
      'tiktok': { icon: 'fa-brands fa-tiktok', tooltip: 'TikTok' },
      'yelp': { icon: 'fa-brands fa-yelp', tooltip: 'Yelp' }
    };

    // Direct source: distinguish organic vs returning
    if (source === 'direct') {
      if (medium === 'returning') {
        return <i className="fa-sharp fa-solid fa-arrow-rotate-right" title="Returning Customer" />;
      }
      return <i className="fa-sharp fa-solid fa-seedling" title="Organic" />;
    }

    const iconData = iconMap[source] || { icon: 'fa-sharp fa-solid fa-circle-info', tooltip: utmSource || 'Unknown' };
    return <i className={iconData.icon} title={iconData.tooltip} />;
  }

  iconState = (state, specialistAction, utmSource, utmMedium) => {
    // For specialists viewing referrals, use their action status for early stages only
    if (this.state.userType === "installer" && specialistAction) {
      switch (specialistAction) {
        case "available": return <i className="fa-sharp fa-solid fa-handshake" title="Dealer Referral"></i>; // OFFERED state - always dealer
        case "owned": return this.getSourceIcon(utmSource, utmMedium); // CLAIMED state - show source
        default: return <i className="fa-sharp fa-solid fa-circle-question"></i>;
      }
    }

    // For dealers viewing referrals (all stages)
    switch (state) {
      // Early referral stages - referral-specific icons
      case "NEW": return <i className="fa-sharp fa-solid fa-folder" title="New" />;
      case "CONTACT": return <i className="fa-sharp fa-solid fa-envelope" title="Contact" />;
      case "VIEWED": return <i className="fa-sharp fa-solid fa-envelope-open" title="Viewed" />;
      case "OFFERED": return <i className="fa-sharp fa-solid fa-wrench" title="Offered" />;
      case "CLAIMED": return this.getSourceIcon(utmSource, utmMedium); // Show source when claimed
      case "CONVERTED": return <i className="fa-sharp fa-solid fa-comment" title="Converted" />; // Speech bubble for quote/estimate

      // Job progression stages - job icons (after conversion)
      case "SCHEDULED": return <i className="fa-sharp fa-solid fa-calendar" />;
      case "RECEIVED": return <i className="fa-sharp fa-solid fa-battery-empty" />;
      case "STARTED": return <i className="fa-sharp fa-solid fa-battery-half" />;
      case "FINISHED": return <i className="fa-sharp fa-solid fa-car" />;
      case "COMPLETED": return <i className="fa-sharp fa-solid fa-dollar-sign" />;
      case "BOOKED": return <i className="fa-sharp fa-solid fa-calendar" />;

      default: return null;
    }
  }
}

export default withRouter(Referrals);